import { CeilingLightMultipleOutlineIcon } from './CeilingLightMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 11968A7F-D159-497F-9D97-A25CACD6AE8D
 * name ceiling-light-multiple-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ceiling-light-multiple-outline.svg
 * tags
 * - Home Automation 
 */
export const CeilingLampMultipleOutlineIcon = CeilingLightMultipleOutlineIcon;
export default CeilingLampMultipleOutlineIcon